// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CV_wrapper__33gbh","leftSide":"CV_leftSide__2TebG","rightSide":"CV_rightSide__2IdYg","motto":"CV_motto__3uTf4","header":"CV_header__1M-5b"};